import React, { useState, useEffect, useRef } from "react";
import { usePopper } from "react-popper";
import styled from "styled-components";
import ArrowRigth from "../assets/svg/ArrowRigth";
import { Clock } from "../assets/svg/Clock";
import { DropDownIcon } from "../assets/svg/DropDownIcon";
import { PreviewSubject } from "../subjects/PreviewSubject";
import Checkbox from "./CheckBox";
import Modal from "./Modal";
import { TitleText } from "./Text";

interface IProps {
  approve?: any;
  reject?: any;
  status?: string;
  archive?: any;
  request?: any;
  
  isDraft?: boolean;
  isManager?: boolean;
  isAdmin?: boolean;
  openModal?: any;
  pip?: any;
}

const DropdownButton = ({
  approve,
  reject,
  status,
  archive,
  isDraft,
  request,
  pip,
  isManager,
  isAdmin,
  openModal,
}: IProps) => {
  const [visible, setVisibility] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  const referenceRef = useRef<any>(null);
  const popperRef = useRef<any>(null);

  const { styles, attributes } = usePopper(
    referenceRef.current,
    popperRef.current,
    {
      placement: "bottom-start",
      modifiers: [
        {
          name: "offset",
          enabled: true,
          options: {
            offset: [0, 0],
          },
        },
      ],
    }
  );
  useEffect(() => {
    // listen for clicks and close dropdown on body
    document.addEventListener("mousedown", handleDocumentClick);
    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, []);

  function handleDocumentClick(event): any {
    if (popperRef.current.contains(event.target)) {
      return;
    }
    setVisibility(false);
  }
  function handleDropdownClick(event) {
    setVisibility(!visible);
  }

  return (
    <React.Fragment>
      {isOpen && (
        <Modal
          title="Terms and Conditions"
          noFooter
          closeModal={() => setIsOpen(false)}
        >
          <TermsContainer>
            <Terms>
              <svg viewBox="0 0 286.054 286.054" width={24} height={24}>
                <path
                  d="M143.027 0C64.04 0 0 64.04 0 143.027c0 78.996 64.04 143.027 143.027 143.027 78.996 0 143.027-64.022 143.027-143.027C286.054 64.04 222.022 0 143.027 0zm0 259.236c-64.183 0-116.209-52.026-116.209-116.209S78.844 26.818 143.027 26.818s116.209 52.026 116.209 116.209-52.026 116.209-116.209 116.209zm.009-196.51c-10.244 0-17.995 5.346-17.995 13.981v79.201c0 8.644 7.75 13.972 17.995 13.972 9.994 0 17.995-5.551 17.995-13.972V76.707c-.001-8.43-8.001-13.981-17.995-13.981zm0 124.997c-9.842 0-17.852 8.01-17.852 17.86 0 9.833 8.01 17.843 17.852 17.843s17.843-8.01 17.843-17.843c-.001-9.851-8.001-17.86-17.843-17.86z"
                  fill="#F092A8"
                />
              </svg>
              <TitleText>
                By requesting this approval, you are accepting the terms and
                conditions outlined in the performance contract.
              </TitleText>
            </Terms>
            <ActionsContainer>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1em",
                }}
              >
                <Checkbox
                  checked={checked}
                  handleChange={(e) => setChecked(e.target.checked)}
                />
                <TitleText
                  style={{
                    marginLeft: "1em",
                  }}
                >
                  I have read and agree to the terms set out in the performance
                  contract.
                </TitleText>
              </label>

              <Button
                backgroundColor="#01A8CE"
                onClick={() => openModal(true)}
                style={{ width: "20em" }}
              >
                View performance contract <ArrowRigth />
              </Button>
            </ActionsContainer>
            <ModalFooter>
              {checked && (
                <Button
                  backgroundColor="#01A8CE"
                  style={{
                    width: "5em",
                    marginRight: "1em",
                    background: "#fff",
                    color: "#214160",
                  }}
                  onClick={() => {
                    request();
                    setIsOpen(false);
                  }}
                >
                  Ok
                </Button>
              )}
              <Button
                backgroundColor="#01A8CE"
                style={{ width: "5em" }}
                onClick={() => setIsOpen(false)}
              >
                Cancel
              </Button>
            </ModalFooter>
          </TermsContainer>
        </Modal>
      )}
      {
        <Button
          backgroundColor={status === "Approved" ? "#81ECC3" : "#D51067"}
          ref={referenceRef}
          onClick={handleDropdownClick}
        >
          {status}
          <DropDownIcon stroke="#fff" />
        </Button>
      }

      <div ref={popperRef} style={styles.popper} {...attributes.popper}>
        <DropdownContainer style={styles.offset} visible={visible}>
          {isDraft ? (
            <>
              <DropdownItem
                onClick={(e) => {
                  setIsOpen(true);
                  PreviewSubject.next(2);
                  setVisibility(false);
                }}
              >
                <TitleText>Request</TitleText>
              </DropdownItem>
            </>
          ) : (
            <>
              {" "}
              {status !== "Approved" && (
                <DropdownItem
                  onClick={(e) => {
                    approve();
                    setVisibility(false);
                  }}
                >
                  <TitleText>Approve</TitleText>
                </DropdownItem>
              )}
              <DropdownItem
                onClick={(e) => {
                  reject();
                  setVisibility(false);
                }}
              >
                <TitleText>Reject</TitleText>
              </DropdownItem>
              {isAdmin && (
                <DropdownItem
                  onClick={(e) => {
                    archive();
                    setVisibility(false);
                  }}
                >
                  <TitleText>Archive</TitleText>
                </DropdownItem>
              )}
              {isAdmin && (
              <DropdownItem
                onClick={(e) => {
                  pip();
                  setVisibility(false);
                }}
                
              >
                <TitleText>PIP</TitleText>
              </DropdownItem>
              )}
            </>
          )}
        </DropdownContainer>
      </div>
    </React.Fragment>
  );
};

export const DropdownContainer = styled.div<{ visible: boolean }>`
  display: ${(props) => (props.visible ? "flex" : "none")};
  width: 125%;
  flex-direction: column;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.14);
  padding: 5px;
  z-index: 1000;
`;

export const DropdownItem = styled.div`
  display: flex;
  justify-content: flex-start;
  height: 40px;
  padding-right: 10px;
  padding-left: 10px;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: #d3dbff;
  }
  &:active {
    font-weight: 700;
    color: #00ffff;
  }
`;
export const Button = styled.button<{ backgroundColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 0.5em;
  padding: 0.5em 1em;
  background-color: ${(props) => props.backgroundColor};
  color: #fff;
  font-size: 12;
  font-weight: 700;
  border: none;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`;

const TermsContainer = styled.div`
  display: flex;
  /* grid-template-rows: 2fr 1fr; */
  margin-top: 1em;
  flex-direction: column;
`;
const Terms = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid #f092a8;
  padding: 1em 0.5em;
  border-radius: 0.5em;
  height: 8em;
  ${TitleText} {
    padding-top: 0.5em;
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1em;
`;

const ModalFooter = styled.div`
  display: flex;
  margin-left: auto;
  margin-top: 1em;
`;

export default DropdownButton;
